class DiscountCodeProductLimit {
  None() {
    return 0;
  }
  AllProducts() {
    return 1;
  }
  CertainProduct() {
    return 2;
  }
  IvrOnly() {
    return 3;
  }
  SecretaryOnly() {
    return 4;
  }
  FaxOnly() {
    return 5;
  }
  LineOnly() {
    return 6;
  }
}
export default new DiscountCodeProductLimit();
